import type { AccidentReportViewModel } from "#accident-statement/schema";
import { useMemo } from "react";
import { useReport } from "./ReportContext";

export function getReportToken(report: AccidentReportViewModel): string {
  if ("tokenA" in report) return report.tokenA;
  if ("tokenB" in report) return report.tokenB;
  throw new Error("No token found in report");
}

export function useReportToken(): string {
  const report = useReport();

  return useMemo(() => getReportToken(report), [report]);
}
